export default __webpack_public_path__ + "static/media/JSS.4cd5ec28.png";